// Domain constants for the tas-program-template resource (relocated from the
// legacy Model's static members ahead of models/ deletion).

/**
 * Maps a document-classification key to the program-template field key that
 * holds the attachment-field definition for that classification.
 */
export const FIELD_KEY_BY_CLASSIFICATION: Record<string, string> = {
  PROGRAM_APPROVAL_DOCUMENTS: 'PROGRAM_APPROVAL_DOCUMENTS_ATTACHMENT_FIELD',
  COURSE_APPROVAL_DOCUMENTS: 'COURSE_APPROVAL_DOCUMENTS_ATTACHMENT_FIELD',
  COMPLETION_DOCUMENTS: 'COMPLETION_DOCUMENTS_ATTACHMENT_FIELD',
  PROGRAM_COMPLETION_DOCUMENTS: 'PROGRAM_COMPLETION_DOCUMENTS_ATTACHMENT_FIELD',
};
